import styled from 'styled-components';
import { tablet_portrait_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const BrandLogosStyles = styled.div`
  background-color: ${Colors.secondary.summerNight.standard};

  .brand-logos-container {
    padding-bottom: 70px;
  }

  .brand-logos-mobile {
    display: block;
    margin: 0 auto;
    width: 80%;
    max-width: 356px;
  }

  @media only screen and (min-width: ${tablet_portrait_breakpoint}px) {
    .brand-logos-container {
      padding-bottom: 50px;
    }

    .brand-logos-desktop {
      display: block;
      margin: 0 auto;
      width: 80%;
      max-width: 1140px;
    }
  }
`;
